var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 9 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18.164 14.236-2.619-2.618L9 18.164v2.618h2.618zM20.42 12.002a1.31 1.31 0 0 0 0-1.851l-.768-.767a1.31 1.31 0 0 0-1.851 0l-.946.946 2.618 2.619z"
}))));
export default SvgPencil;